import { JSX } from "react";
import { useAppDispatch } from "../../../app/hooks";
import { setIsDeleteAccountModalOpen } from "../EmployeeInactiveSlice";
import DeleteIcon from "../../../common/images/delete.svg?react";

export const EmployeeInactiveDeleteLink = (): JSX.Element => {
    const dispatch = useAppDispatch();

    return (
        <div className={"p-employee-inactive__content__delete-link"}>
            <p>
                Heb je jouw certificaten gedownload en wil je je account zelf al
                permanent verwijderen?
            </p>
            <button
                type="button"
                onClick={() => dispatch(setIsDeleteAccountModalOpen(true))}
            >
                <DeleteIcon />
                <span>Account definitief verwijderen</span>
            </button>
        </div>
    );
};
